"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.WildcardCountAggregator = void 0;
const bus_bindings_aggregator_factory_1 = require("@comunica/bus-bindings-aggregator-factory");
const utils_expression_evaluator_1 = require("@comunica/utils-expression-evaluator");
const RdfString = __importStar(require("rdf-string"));
class WildcardCountAggregator extends bus_bindings_aggregator_factory_1.AggregateEvaluator {
    bindingValues = new Map();
    state = undefined;
    constructor(evaluator, distinct, throwError) {
        super(evaluator, distinct, throwError);
    }
    putTerm(_term) {
        // Do nothing, not needed
    }
    async putBindings(bindings) {
        if (!this.handleDistinct(bindings)) {
            if (this.state === undefined) {
                this.state = 0;
            }
            this.state += 1;
        }
    }
    emptyValueTerm() {
        return (0, utils_expression_evaluator_1.typedLiteral)('0', utils_expression_evaluator_1.TypeURL.XSD_INTEGER);
    }
    termResult() {
        if (this.state === undefined) {
            return this.emptyValue();
        }
        return (0, utils_expression_evaluator_1.typedLiteral)(String(this.state), utils_expression_evaluator_1.TypeURL.XSD_INTEGER);
    }
    /**
     * Returns true if the given bindings should be skipped.
     * @param bindings
     * @private
     */
    handleDistinct(bindings) {
        if (this.distinct) {
            const bindingList = [...bindings];
            bindingList.sort((first, snd) => first[0].value.localeCompare(snd[0].value));
            const variables = bindingList.map(([variable]) => variable.value).join(',');
            const terms = bindingList.map(([, term]) => RdfString.termToString(term)).join(',');
            const set = this.bindingValues.get(variables);
            const result = set !== undefined && set.has(terms);
            // Add to the set:
            if (!set) {
                this.bindingValues.set(variables, new Set());
            }
            this.bindingValues.get(variables).add(terms);
            return result;
        }
        return false;
    }
}
exports.WildcardCountAggregator = WildcardCountAggregator;
//# sourceMappingURL=WildcardCountAggregator.js.map